const en = {
    'project.global.fields.email': 'Email',
    'project.global.fields.password': 'Password',
    'project.app.Header.login': 'Sign In',
    'project.app.Header.logout': 'Logout',
    'project.global.buttons.UpdateProfile': 'Update Profile',
    'project.global.buttons.back': 'Back',
    'project.global.buttons.continue': 'Continue',
    'project.global.buttons.filter': 'Filter',
    'project.global.buttons.next': 'Next',
    'project.global.buttons.save': 'Save',
    'project.users.SignUp.title': 'Sign Up',
    "project.global.fields.firstName": 'First name',
    'project.global.fields.lastName': 'Last name',
    'project.users.ChangePassword.fields.confirmNewPassword': 'Confirm new password',
    'project.users.ChangePassword.fields.newPassword': 'New password',
    'project.users.ChangePassword.fields.oldPassword': 'Old password',
    'project.users.ChangePassword.title': 'Change password',
    'project.users.UpdateProfile.title': 'Update profile',
    'project.users.UpdateProfileImage.title': 'Add Image',
    'project.user.userImage.title': 'Add your user image',
    'project.global.fields.title': 'Title',
    'project.global.fields.url': "URL",
    'project.global.fields.userName': 'UserName',
    'project.users.Profile.title': 'Title',
    'project.users.CreatePost.title': 'Create Post',
    'project.users.MyPosts.title': 'MyPosts',
    'project.app.Header.quiz': 'Quiz',
    'project.global.fields.points': 'Points',
    'project.app.Header.Awards': 'Awards',
    'project.users.MyAwards.title': 'MyAwards',
    'project.entities.AwardDetails.Points': 'Requiered Points: ',
    'project.entities.AwardDetails.Button': 'Choose Award',
    'project.app.Header.historic': 'Historic',
    'project.modules.historic.podiums': 'Podiums',
    'project.entities.PodiumDetails.date':'Event Date',
    'project.entities.PodiumDetails.winner': 'Winner',
    'project.entities.PodiumDetails.TeamWinner':'Team Winner',
    'project.entities.PodiumDetails.second': 'Second Place',
    'project.entities.PodiumDetails.third':'Third Place',
    'project.entities.Circuits': 'F1 Circuits',
    'project.entities.Podiums': 'Podiums',
    'project.app.Header.calendar': 'Calendar',
    'project.events.events': 'Events',
    'project.events.events.create': 'Create Event',
    'project.common.notifications.button': 'Notifications',
    'project.users.SignUp.fields.confirmPassword': 'Confirm Password',
    'project.global.fields.event.name': 'Event Name',
    'project.global.fields.event.description': 'Description',
    'project.global.fields.events.location' : 'Location',
    'project.global.fields.events.date' : 'Event Date',
    'project.Footer': 'Overcut',
    'project.entities.EventDetails.name': 'Event',
    'project.entities.EventDetails.description': 'Description',
    'project.entities.EventDetails.location': 'Location',
    'project.entities.EventDetails.date': 'Date',
    'project.entities.EventDetails.image':'Image',
    'project.entities.EventDetails.button': 'Create Notification',
    'project.entities.Events': 'Events',
    'project.global.dropdown.sortOrderDES': 'Des order',
    'project.global.dropdown.sortOrderDefault': 'Default order',
    'project.global.dropdown.sortOrderASC': 'Asc order',
    'project.global.dropdown.allCategories': 'All Categories',
    'project.global.dropdown.sortCriteriaAll': 'All',
    'project.global.dropdown.sortCriteriaCreationDate': 'Creation Date',
    'project.users.CreateEvent.title': 'Create Event',
    'project.About_Us': 'About Us',
    'project.Contact': 'Contact',
    'project.modules.historic.stats': 'Stats',
    'project.global.fields.subtitle': 'Subtitle',
    'project.global.fields.article': 'Article',
    'project.global.fields.category': 'Category',
    'project.posts.CreatePost.title': 'Create Post',
    'project.user.addImage': 'Add Image',
    'project.user.postImage.title': 'Image title',
    'project.global.post.addImageCreatePost': 'Add Image',
    'project.entities.User.Points': 'User Points: ',
    'project.entities.Quiz.Answers': 'The correct answer is: ',
    'project.entities.stats.circuit': 'stats for the last 10 years',
    'project.entities.stats.teams.wins': 'Total teams wins in the last 10 seasons',
    'project.entities.stats.drivers.podiums': 'Drivers with more podiums in F1',
    'project.entities.stats.drivers.wins': 'Drivers with more wins in F1',
    'project.entities.stats.drivers.championships': 'Drivers with more championships in F1',
    'project.entities.EventDetails.button.delete': 'Delete Event',
    'project.entities.SignUp.Journalist': 'I´m journalist',
    'project.no_awards': 'No awards available',
    'project.entities.Awards.User.Points': 'Not enough points',
    'project.global.post.modifyPost': 'Modify Post',
    'project.global.fields.modifytitle': 'Title',
    'project.global.fields.modifysubtitle': 'Subtitle',
    'project.global.fields.modifyarticle': 'Article',
    'project.global.fields.modifycategory': 'Category',
    'project.entities.Post.Modify': 'Modify Post',
    'project.entities.Post.Delete': 'Delete Post',
    'project.entities.Posts.MyPosts': 'MyPosts',
    'project.entities.Quiz.getPoints': 'You got ',
    'project.points': 'points',
    'project.YourPoints': 'Your points',
    'project.Circuit.Details.Name': 'Circuit: ',
    'project.Circuit.Details.Distance': 'Distance: ',
    'project.Circuit.Details.Laps': 'Laps: ',
    'project.Circuit.Details.Image': 'Image: ',
    'project.Circuit.Details.Team': 'Most successful team: ',
    'project.entities.Quiz.Result.Points': 'Points available: ',
    'project.entities.Quiz.Result.QuizPoints': 'Points achieved: ',
    'project.entities.Quiz.Result.Questions': 'Total questions: ',
    'project.entities.Quiz.Result.ButtonHome': 'Return to the beginning',
    'project.entities.Quiz.Result.Excellent': 'Excellent! You got more than half the points',
    'project.entities.Quiz.Result.Retry': 'Try to do it better next time',
    'project.entities.Quiz.Result': 'Results',
    'project.entities.Award.Result.Achieved': 'Well done! You achieved the award!',
    'project.entities.Award.Result.ButtonHome': 'Go to my awards list',
    'project.app.Header.minigames': 'OverCutGames',
    'crossword.title': 'Crossword',
    'crossword.subtitle': 'Fill in all the words and prove you know F1 history',
    'crossword.reset': 'Reset crossword',
    'crossword.clues.horizontal': 'Horizontal Clues',
    'crossword.clues.vertical': 'Vertical Clues',
    'crossword.validate': 'Check word',
    'quiz.loading': 'Preparing the starting grid...',
    'quiz.intro.title': 'Welcome to the OverCut Quiz',
    'quiz.intro.subtitle': 'Show your knowledge about Formula 1',
    'quiz.intro.play': 'Play now',
    'quiz.result.title': 'Race finished!',
    'quiz.result.subtitle': 'Thanks for taking part in this OverCut quiz!',
    'quiz.result.points': '🏁 Points:',
    'quiz.result.total': 'Total achieved:',
    'quiz.result.point': 'points',
    'quiz.result.back': 'Return to home',
    'project.users.CreateJournalist.title': 'Register Journalist',
    'project.app.Header.ranking': 'Ranking',
    'project.users.EmailConfirmationPending.title': 'Sign Up Complete!',
    'project.users.EmailConfirmationPending.message': 'Check your email and activate your account using the link you received in order to sign in. The email may take about 5 minutes to arrive. If it’s not in your inbox, please check your spam folder.',
    'project.users.Login.title': 'Sign In',
    'project.users.Login.rememberMe': 'Remember me',
    'project.global.buttons.login': 'Sign In',
    'project.users.Login.signUpPrompt': 'Do not have an account? Sign Up',
    'project.exceptions.IncorrectLoginException': 'Incorrect Login',
    "validation.password.length": "At least 8 characters",
    "validation.password.uppercase": "At least one uppercase letter",
    "validation.password.number": "At least one number",
    "validation.password.special": "At least one special character",
    "project.global.validator.passwordsDoNotMatch": "Password does not match",
    "project.emailVerification.loading": "Verifying your account...",
    "project.emailVerification.success": "Your account has been successfully activated!",
    "project.emailVerification.loginButton": "Log in",
    "project.emailVerification.invalidOrExpired": "Verification link is invalid or expired",
    "project.emailVerification.goBack": "Return to homepage",
    "project.global.errors.title": "Incorrect old password",
    'project.users.confirmPasswordChange.success': '✅ Password updated successfully',
    'project.users.confirmPasswordChange.error': '❌ Invalid or expired token',
    'project.global.buttons.backHome': 'Back to home',
    'project.users.passwordChangeRequested': 'We’ve sent a confirmation email to apply your password change.',
    "project.app.Header.f1hub": "OverCutHub",
    "postEditor.newPost": "New Post",
    "postEditor.title": "Title",
    "postEditor.subtitle": "Subtitle",
    "postEditor.category": "Category",
    "postEditor.mainImage": "Main post image",
    "postEditor.addSection": "Add subsection",
    "postEditor.section": "Section",
    "postEditor.sectionTitle": "Section title",
    "postEditor.addText": "+ Text",
    "postEditor.addImage": "+ Image",
    "postEditor.addTweet": "+ Tweet",
    "postEditor.textBlock": "Text",
    "postEditor.tweetBlock": "Tweet URL",
    "postEditor.publish": "Publish post",
    "post.caption.image": "Caption:",
    "post.caption.tweet": "Tweet note:",
    "postEditor.mainImageCaption": "Main image caption",
    "post.caption.mainImage": "Caption: ",
    "project.app.Header.about": "What is OverCut?",
    "project.global.buttons.pleaseWait": "Please wait...",
    "project.About": "About OverCut",
    "project.LegalNotice": "Legal Notice",
    "project.TermsOfUse": "Terms of Use",
    "project.PrivacyPolicy": "Privacy Policy",
    "project.CookiesPolicy": "Cookies Policy",
    "project.ContactEmail": "Contact:",
    "project.AllRightsReserved": "All rights reserved.",
    "project.IntellectualProperty": "Intellectual Property",
    "project.LegalPolicies": "Legal Policies",
    "project.LegalPoliciesSubtitle": "Find all our legal documents in one place.",
    "project.ReadMore": "Read more",
    "project.LegalNoticeDesc": "Ownership, contact, and general info.",
    "project.TermsOfUseDesc": "Rules for using OverCut.",
    "project.PrivacyPolicyDesc": "Data processing and your rights.",
    "project.IntellectualPropertyDesc": "IP ownership and permitted uses.",
    "project.CookiesPolicyDesc": "Cookies used and settings.",
    'project.users.Login.forgotPassword': 'Forgot your password?',
"project.users.requestPasswordReset.title": 'Reset password',
"project.users.requestPasswordReset.send": 'Send email',
"project.users.passwordResetRequested": 'If the email exists, we’ve sent a message with a reset link. The email may take about 5 minutes.',
	"project.users.passwordReset.title": 'New password',
	"project.users.passwordReset.success": 'Your password has been reset successfully',
	"project.users.passwordReset.error": 'Invalid or expired link'
}
export default en;
